export var PUSH_TYPING = "PUSH_TYPING";
export var pushTyping = function pushTyping(typing, authUserId) {
  return {
    typing: typing,
    authUserId: authUserId,
    type: PUSH_TYPING
  };
};